import { render, staticRenderFns } from "./HospitalComponent.vue?vue&type=template&id=747ad73d&scoped=true&"
import script from "./HospitalComponent.vue?vue&type=script&lang=js&"
export * from "./HospitalComponent.vue?vue&type=script&lang=js&"
import style0 from "./HospitalComponent.vue?vue&type=style&index=0&id=747ad73d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747ad73d",
  null
  
)

export default component.exports